import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=e4dcaa1e&scoped=true&"
import script from "./roadmap.vue?vue&type=script&lang=js&"
export * from "./roadmap.vue?vue&type=script&lang=js&"
import style0 from "./roadmap.vue?vue&type=style&index=0&id=e4dcaa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dcaa1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VContainer,VRow,VSpacer})
